import http from './http'
//
/**
 *  @parms resquest 请求地址
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

const mbl = `/MBL`

function getMBLPriorityList(params) {
  return http.post(`${mbl}/getMBLPriorityList`, params)
}
function saveMBLPriority(params) {
  return http.post(`${mbl}/saveMBLPriority`, params)
}
function getMBLFollowUpTerminologyList(params) {
  return http.post(`${mbl}/getMBLFollowUpTerminologyList`, params)
}
function getMBLFollowUpTerminology(params) {
  return http.get(`${mbl}/getMBLFollowUpTerminology`, params)
}
function saveMBLFollowUpTerminology(params) {
  return http.post(`${mbl}/saveMBLFollowUpTerminology`, params)
}
function switchMBLFollowUpTerminology(params) {
  return http.post(`${mbl}/switchMBLFollowUpTerminology`, params)
}
function switchMBLPriority(params) {
  return http.get(`${mbl}/switchMBLPriority`, params)
}
function confirmMBL(params) {
  return http.post(`${mbl}/confirmMBL`, params)
}
function refuseMBL(params) {
  return http.post(`${mbl}/refuseMBL`, params)
}
function getMBLPageList(params) {
  return http.post(`${mbl}/getMBLPageList`, params)
}
function getMBLFollowUpList(params) {
  return http.post(`${mbl}/getMBLFollowUpList`, params)
}
function confirmMBLInfo(params) {
  return http.get(`${mbl}/confirmMBLInfo`, params)
}
function getMBLDetail(params) {
  return http.get(`${mbl}/getMBLDetail`, params)
}
function getMBLProduct(params) {
  return http.get(`${mbl}/getMBLProduct`, params)
}
function saveMBLProduct(params) {
  return http.post(`${mbl}/saveMBLProduct`, params)
}
function forecastAccepted(params) {
  return http.post(`${mbl}/forecastAccepted`, params)
}
function addMBLFollowUp(params) {
  return http.post(`${mbl}/addMBLFollowUp`, params)
}
function getOrderDetailPages(params) {
  return http.post(`${mbl}/getOrderDetailPages`, params)
}
function arrivedAndDischarge(params) {
  return http.post(`${mbl}/arrivedAndDischarge`, params)
}
function getFacilityDetail(params) {
  return http.get(`${mbl}/getFacilityDetail`, params)
}
function notifyCompanyUploadFile(params) {
  return http.get(`${mbl}/notifyCompanyUploadFile`, params)
}
function reservation(params) {
  return http.post(`${mbl}/reservation`, params)
}
function reservationArrived(params) {
  return http.get(`${mbl}/reservationArrived`, params)
}
function arrivedFacility(params) {
  return http.post(`${mbl}/arrivedFacility`, params)
}
function departruedFacility(params) {
  return http.post(`${mbl}/departruedFacility`, params)
}
function mblFinished(params) {
  return http.get(`${mbl}/mblFinished`, params)
}
function getMBLDDL(params) {
  return http.get(`${mbl}/getMBLDDL`, params)
}
function existsMBL(params) {
  return http.get(`${mbl}/existsMBL`, params)
}
function getMBLSendWay(params) {
  return http.get(`${mbl}/getMBLSendWay`, params)
}
function getTruckPages(params) {
  return http.post(`${mbl}/getTruckPages`, params)
}
function markNormal(params) {
  return http.post(`${mbl}/markNormal`, params)
}
function markException(params) {
  return http.post(`${mbl}/markException`, params)
}
function truckDetail(params) {
  return http.get(`${mbl}/truckDetail`, params)
}
function uploadPOD(params) {
  return http.upload(`/api/${mbl}/uploadPOD`, params)
}
function readMainifestExcel(params, formData) {
  return http.upload(`/api/${mbl}/readMainifestExcel?mblId=${params.mblId}`, formData)
}
function uploadISA(params) {
  return http.upload(`/api/${mbl}/uploadISA`, params)
}
function uploadBOL(params) {
  return http.upload(`/api/${mbl}/uploadBOL`, params)
}
function getTruckInfo(params) {
  return http.get(`${mbl}/getTruckInfo`, params)
}
function addTruckSurcharge(params) {
  return http.post(`${mbl}/addTruckSurcharge`, params)
}
function exportTruckExcel(params) {
  return http.download(`${mbl}/exportTruckExcel`, params, 'post')
}
function getMBLTrackList(params) {
  return http.get(`${mbl}/getMBLTrackList`, params)
}
function airMBLArrived(params) {
  return http.get(`${mbl}/airMBLArrived`, params)
}
function GGTGetSCINList(params) {
  return http.get(`${mbl}/GGTGetSCINList`, params)
}

function GetDoTemplate(params) {
  return http.get(`${mbl}/GetDoTemplate`, params)
}
function ChangeDoTemplate(params) {
  return http.post(`${mbl}/ChangeDoTemplate`, params)
}
function PushMBLToGGT(params) {
  return http.post(`${mbl}/PushMBLToGGT`, params)
}
function GGTChangeSCIN(params) {
  return http.post(`${mbl}/GGTChangeSCIN`, params)
}
function DeleteDoTemplate(params) {
  return http.get(`${mbl}/DeleteDoTemplate`, params)
}
function MBLHoldDetail(params) {
  return http.get(`${mbl}/MBLHoldDetail`, params)
}
function getHoldReasonPages(params) {
  return http.post(`${mbl}/getHoldReasonPages`, params)
}
function addHoldReason(params) {
  return http.post(`${mbl}/addHoldReason`, params)
}
function updateHoldReason(params) {
  return http.post(`${mbl}/updateHoldReason`, params)
}
function deleteHoldReason(params) {
  return http.delete(`${mbl}/deleteHoldReason`, params)
}
function getHoldReasonDropdown(params) {
  return http.get(`${mbl}/getHoldReasonDropdown`, params)
}
function holdMBL(params) {
  return http.post(`${mbl}/holdMBL`, params)
}
function realeaseMBL(params) {
  return http.get(`${mbl}/realeaseMBL`, params)
}
function getFMSReqeust(params) {
  return http.get(`${mbl}/getFMSReqeust`, params)
}
function fmsMBLFollowUpList(params) {
  return http.get(`${mbl}/fmsMBLFollowUpList`, params)
}
function pushToFMS(params, id) {
  return http.post(`${mbl}/pushToFMS?mblId=${id}`, params)
}
function addFMSMBLFollowUp(params) {
  return http.upload(`/api/${mbl}/addFMSMBLFollowUp`, params)
}
function onLoadMBL(params) {
  return http.post(`${mbl}/onLoadMBL`, params)
}
function inspectionSiteList(params) {
  return http.get(`${mbl}/inspectionSiteList`, params)
}
function saveInspectionSite(params) {
  return http.post(`${mbl}/saveInspectionSite`, params)
}
function getMBLPriceTemplate(params) {
  return http.post(`${mbl}/getMBLPriceTemplate`, params)
}
function addMBLPriceTemplate(params) {
  return http.post(`${mbl}/addMBLPriceTemplate`, params)
}
function updateMBLPriceTemplate(params) {
  return http.post(`${mbl}/updateMBLPriceTemplate`, params)
}
function getMBLPriceTemplateDetail(params) {
  return http.get(`${mbl}/getMBLPriceTemplateDetail`, params)
}
function mblHoldRecordPages(params) {
  return http.post(`${mbl}/mblHoldRecordPages`, params)
}
function mblHoldRecordSetInspec(params) {
  return http.post(`${mbl}/mblHoldRecordSetInspec`, params)
}
function mblHoldRecordSetStatus(params) {
  return http.post(`${mbl}/mblHoldRecordSetStatus`, params)
}
function mblHoldRecordSetBgLabel(params) {
  return http.post(`${mbl}/mblHoldRecordSetBgLabel`, params)
}
function mblHoldRecordSetHoldInfo(params) {
  return http.post(`${mbl}/mblHoldRecordSetHoldInfo`, params)
}
function forecastRefuse(params) {
  return http.get(`${mbl}/forecastRefuse`, params)
}
function searchOnLoadMBLT6(params) {
  return http.get(`${mbl}/searchOnLoadMBLT6`, params)
}
function GGTGetAddress(params) {
  return http.get(`${mbl}/GGTGetAddress`, params)
}
function updateMBLSendWayRemarks(params) {
  return http.get(`${mbl}/updateMBLSendWayRemarks`, params)
}
function rejectForecast(params) {
  return http.get(`${mbl}/rejectForecast`, params)
}
function mblFileConfig(params) {
  return http.get(`${mbl}/mblFileConfig`, params)
}
function dispatchMblSendWay(params) {
  return http.post(`${mbl}/dispatchMblSendWay`, params)
}
function dispatchTransferOwner(params) {
  return http.post(`${mbl}/dispatchTransferOwner`, params)
}
function voidMBL(params) {
  return http.get(`${mbl}/voidMBL`, params)
}
function revertT11ToDraft(params) {
  return http.get(`${mbl}/revertT11ToDraft`, params)
}

function deleteMBL(params) {
  return http.get(`${mbl}/deleteMBL`, params)
}
function restoreMBL(params) {
  return http.get(`${mbl}/restoreMBL`, params)
}
function createMbl(params) {
  return http.post(`${mbl}/createMbl`, params)
}
function dispatchPrivateMblSendWay(params) {
  return http.post(`${mbl}/dispatchPrivateMblSendWay`, params)
}
function uploadOwerISA(file, params) {
  return http.upload(`/api/${mbl}/uploadOwerISA?podId=${params}`, file)
}
function dispatchTransferTruck(formData, fn) {
  return http.upload(`/api/${mbl}/dispatchTransferTruck`, formData, fn)
}
function dispatchTransferReadExcel(params, formData, fn) {
  return http.upload(`/api/${mbl}/dispatchTransferReadExcel?mblId=${params.mblId}&isAmazon=${params.isAmazon}`, formData, fn)
}
function dispatchTransferPrivateToAmazon(params) {
  return http.post(`${mbl}/dispatchTransferPrivateToAmazon`, params)
}
function dispatchTransferExpress(params) {
  return http.post(`${mbl}/dispatchTransferExpress`, params)
}
function dispatchTransferAmazonToPrivate(params) {
  return http.post(`${mbl}/dispatchTransferAmazonToPrivate`, params)
}
function batchUpdateDeliveryTime(params) {
  return http.post(`${mbl}/batchUpdateDeliveryTime`, params)
}

function getMBLDispatchRecordList(params) {
  return http.post(`${mbl}/getMBLDispatchRecordList`, params)
}

function saveMblSendWay(params) {
  return http.post(`${mbl}/saveMblSendWay`, params)
}
function deleteMblSendWay(params) {
  return http.delete(`${mbl}/deleteMblSendWay`, params)
}
function mergeMainifestSystem(params) {
  return http.post(`${mbl}/mergeMainifestSystem`, params)
}
function mergeMainifestSystem1(params) {
  return http.post(`${mbl}/mergeMainifestSystem1`, params)
}

function mblHandler(params) {
  return http.get(`${mbl}/mblHandler`, params)
}
function updateMBLHandler(params) {
  return http.post(`${mbl}/updateMBLHandler`, params)
}

function mblModifyInfo(params) {
  return http.get(`${mbl}/mblModifyInfo`, params)
}
function modifyMBL(params) {
  return http.post(`${mbl}/modifyMBL`, params)
}
function unknowProducts(params) {
  return http.get(`${mbl}/unknowProducts`, params)
}
function readMainifest(params) {
  return http.get(`${mbl}/readMainifest`, params)
}
function directDeliveryPages(params) {
  return http.post(`${mbl}/directDeliveryPages`, params)
}
function modifyDirectDelivery(params) {
  return http.post(`${mbl}/modifyDirectDelivery`, params)
}
function syncAbiTrack(params) {
  return http.post(`${mbl}/syncAbiTrack`, params)
}
function updateHoldResult(params) {
  return http.post(`${mbl}/updateHoldResult`, params)
}
function modifyDeliverySendWay(params) {
  return http.post(`${mbl}/modifyDeliverySendWay`, params)
}
function containerFinished(params) {
  return http.get(`${mbl}/containerFinished`, params)
}
function modifyMBLRemark(params) {
  return http.post(`${mbl}/modifyMBLRemark`, params)
}
function modifyDeliveryRemark(params) {
  return http.post(`${mbl}/modifyDeliveryRemark`, params)
}
function modifyMBLPU(params) {
  return http.post(`${mbl}/modifyMBLPU`, params)
}
function mblHoldFiles(params) {
  return http.get(`${mbl}/mblHoldFiles`, params)
}
function confirmT11Clearance(params) {
  return http.upload(`/api/${mbl}/confirmT11Clearance`, params)
}
function getClearanceStatus(params) {
  return http.get(`${mbl}/getClearanceStatus`, params)
}
function getImporterDrapdown(params) {
  return http.get(`${mbl}/getImporterDrapdown`, params)
}
function addImporter(params) {
  return http.post(`${mbl}/addImporter`, params)
}

const ISF = `/ISF`

function getISFPageList(params) {
  return http.post(`${ISF}/getISFPageList`, params)
}
function getDetail(params) {
  return http.get(`${ISF}/getDetail`, params)
}
function getStatusEvents(params) {
  return http.get(`${ISF}/getStatusEvents`, params)
}
function create(params) {
  return http.post(`${ISF}/create`, params)
}
function isfMainifestSave(params) {
  return http.post(`${ISF}/isfMainifestSave`, params)
}
function GetImporterStatistics(params) {
  return http.post(`${ISF}/GetImporterStatistics`, params)
}
function synchronousISF(shipmentFileNumber, params) {
  return http.post(`${ISF}/synchronousISF?shipmentFileNumber=${shipmentFileNumber}`, params)
}
function cancelISF(shipmentFileNumber, params) {
  return http.post(`${ISF}/cancelISF?shipmentFileNumber=${shipmentFileNumber}`, params)
}
function sentISFMessage(params) {
  return http.post(`${ISF}/sentISFMessage`, params)
}
function getISFHsCode(params) {
  return http.get(`${ISF}/getISFHsCode`, params)
}
function saveISFTemplate(params) {
  return http.post(`${ISF}/saveISFTemplate`, params)
}
function getISFTemplate(params) {
  return http.get(`${ISF}/getISFTemplate`, params)
}
function deleteISFTemplate(params) {
  return http.delete(`${ISF}/deleteISFTemplate`, params)
}

const T86 = `/T86`
function manifestDetail(params) {
  return http.get(`${T86}/manifestDetail`, params)
}
function manifestRefuse(params) {
  return http.get(`${T86}/manifestRefuse`, params)
}
function manifestAccepted(params) {
  return http.post(`${T86}/manifestAccepted`, params)
}

const forecast = `/Forecast`
function taxProductOptions(params) {
  return http.get(`${forecast}/taxProductOptions`, params)
}
function saveMondaryProduct(params) {
  return http.post(`${forecast}/saveMondaryProduct`, params)
}
function forecastHanding(params) {
  return http.post(`${forecast}/forecastHanding`, params)
}
function changeCalculator(params, type) {
  return http.post(`${forecast}/changeCalculator?type=${type}`, params)
}
function submitForecast(params) {
  return http.post(`${forecast}/submitForecast`, params)
}
function getForecastPages(params) {
  return http.post(`${forecast}/getForecastPages`, params)
}
function cancelForecast(params) {
  return http.get(`${forecast}/cancelForecast`, params)
}
function supTemplateList(params) {
  return http.get(`${forecast}/supTemplateList`, params)
}
function sendEmail(params) {
  return http.post(`${forecast}/sendEmail`, params)
}
function addSupTemplate(params) {
  return http.post(`${forecast}/addSupTemplate`, params)
}
function modifySupTemplate(params) {
  return http.post(`${forecast}/modifySupTemplate`, params)
}

function deleteSupTemplate(params) {
  return http.get(`${forecast}/deleteSupTemplate`, params)
}

function uploadMBLProduct1(params, formData) {
  return http.upload(`/api/${forecast}/uploadMBLProduct1?mblId=${params.mblId}`, formData)
}

const TaxManagement = `/TaxManagement`

function getToBeUploadedQty(params) {
  return http.get(`${TaxManagement}/getToBeUploadedQty`, params)
}
function getForm7501PagedList(params) {
  return http.post(`${TaxManagement}/getForm7501PagedList`, params)
}
function uploadForm7501(params) {
  return http.upload(`/api/TaxManagement/uploadForm7501`, params)
}
function getRejectedRefuseReason(params) {
  return http.post(`${TaxManagement}/getRejectedRefuseReason`, params)
}
function extractTaxContext(params) {
  return http.upload(`/api/TaxManagement/extractTaxContext`, params)
}

const AnDoStatusRecord = `/AnDoStatusRecord`

function getFirmCodeOutputList(params) {
  return http.get(`${AnDoStatusRecord}/getFirmCodeOutputList`, params)
}
function getAnDoStatusRecordPagedList(params) {
  return http.post(`${AnDoStatusRecord}/getAnDoStatusRecordPagedList`, params)
}
function getMBLFileAnOrDoList(params) {
  return http.post(`${AnDoStatusRecord}/getMBLFileAnOrDoList`, params)
}
function addAnAndDoFirmCode(params) {
  return http.post(`${AnDoStatusRecord}/addAnAndDoFirmCode`, params)
}
function sendAnEmail(params) {
  return http.post(`${AnDoStatusRecord}/sendAnEmail`, params)
}
function sendDoEmail(params) {
  return http.post(`${AnDoStatusRecord}/sendDoEmail`, params)
}
function insertDoFile(params) {
  return http.get(`${AnDoStatusRecord}/insertDoFile?mblId=${params.mblId}&firmCode=${params.firmCode}`)
}
const MBLFile = `/MBLFile`
function deleteMBLFile(params) {
  return http.delete(`${MBLFile}/deleteMBLFile`, params)
}

/**
 * 下载文件
 * @param {Object} params - 包含 guid 的对象
 * @returns {Promise} 请求结果
 */
function downLoadMBLFile(params) {
  return http.get(`${MBLFile}/downLoadMBLFile`, params)
}

/**
 * 文件列表
 * @param {Object} params - 查询参数
 * @returns {Promise} 请求结果
 */
function getMBLFileList(params) {
  return http.post(`${MBLFile}/getList`, params)
}
function getGroupList(params) {
  return http.post(`${MBLFile}/getGroupList`, params)
}

function getMBLFileList2(params) {
  return http.post(`${MBLFile}/getMBLFileList`, params)
}

/**
 * 附件类型枚举下拉
 * @returns {Promise} 请求结果
 */
function getMBLUploadFileTypeOption() {
  return http.get(`${MBLFile}/getMBLUploadFileTypeOption`)
}

/**
 * 预览文件
 * @param {Object} params - 包含 guid 的对象
 * @returns {Promise} 请求结果
 */
function previewMBLFile(params) {
  return http.get(`${MBLFile}/previewMBLFile`, { params }) // 假设 params.guid 存在
}

function uploadMBLProduct(params, formData) {
  return http.upload(`/api${MBLFile}/uploadMBLProduct?id=${params.mblId}`, formData)
}
/**
 * 上传文件
 * @param {Object} params - 包含文件和附加信息的对象
 * @returns {Promise} 请求结果
 */
function uploadFile(params) {
  return http.upload(`/api${MBLFile}/uploadFile`, params)
}

const ControlOverInvoices = `/ControlOverInvoices`

function getControlOverInvoicesPagedList(params) {
  return http.post(`${ControlOverInvoices}/getControlOverInvoicesPagedList`, params)
}
function documentReview(params) {
  return http.post(`${ControlOverInvoices}/documentReview`, params)
}
function returnForRetrial(params) {
  return http.get(`${ControlOverInvoices}/returnForRetrial?id=${params}`)
}
function cancel(params) {
  return http.get(`${ControlOverInvoices}/cancel?id=${params}`)
}
function sentUS(params) {
  return http.post(`${ControlOverInvoices}/sentUS`, params)
}
function getInvoiceReviewRecordList(params) {
  return http.get(`${ControlOverInvoices}/getInvoiceReviewRecordList?mblId=${params}`)
}
function modifyInvoiceStatus(params) {
  return http.post(`${ControlOverInvoices}/modifyInvoiceStatus`, params)
}
function uploadInvoiceReviewFile(params) {
  return http.upload(`/api${ControlOverInvoices}/uploadInvoiceReviewFile`, params)
}
function getLatestMBLProductDetail(params) {
  return http.get(`${ControlOverInvoices}/getLatestMBLProductDetail?mblId=${params}`)
}
function systemInvoicePassForAdmin(params) {
  return http.post(`${ControlOverInvoices}/systemInvoicePassForAdmin`, params)
}
function reviewFeedbackForAdmin(params) {
  return http.post(`${ControlOverInvoices}/reviewFeedbackForAdmin`, params)
}
function getHistoryRecordList(params) {
  return http.get(`${ControlOverInvoices}/getHistoryRecordList?mblId=${params}`)
}
function getHistoryRecordDetailList(params) {
  return http.get(`${ControlOverInvoices}/getHistoryRecordDetailList?historyRecordId=${params}`)
}
function restoreVersion(params) {
  return http.get(`${ControlOverInvoices}/restoreVersion?id=${params}`)
}
function aiGenerateInvoice(params) {
  return http.post(`${ControlOverInvoices}/aiGenerateInvoice`, params)
}
function getInvoiceProductDetails(params) {
  return http.get(`${ControlOverInvoices}/getInvoiceProductDetails`, params)
}

const InvoiceTemplate = `/InvoiceTemplate`

function GetSupplierTemplates(params) {
  return http.get(`${InvoiceTemplate}/GetSupplierTemplates`, params)
}
function isActivedSupplierTemplate(params) {
  return http.get(`${InvoiceTemplate}/IsActivedSupplierTemplate`, params)
}
function deleteSupplierTemplate(params) {
  return http.get(`${InvoiceTemplate}/DeleteSupplierTemplate`, params)
}

export {
  getMBLPriorityList,
  saveMBLPriority,
  getMBLFollowUpTerminology,
  getMBLFollowUpTerminologyList,
  saveMBLFollowUpTerminology,
  switchMBLFollowUpTerminology,
  switchMBLPriority,
  getISFPageList,
  getDetail,
  getStatusEvents,
  create,
  confirmMBL,
  getMBLPageList,
  getMBLFollowUpList,
  confirmMBLInfo,
  refuseMBL,
  forecastRefuse,
  getMBLDetail,
  getMBLProduct,
  saveMBLProduct,
  forecastAccepted,
  addMBLFollowUp,
  getOrderDetailPages,
  arrivedAndDischarge,
  getFacilityDetail,
  notifyCompanyUploadFile,
  reservation,
  reservationArrived,
  arrivedFacility,
  departruedFacility,
  mblFinished,
  getMBLDDL,
  existsMBL,
  getMBLSendWay,
  saveMblSendWay,
  getTruckPages,
  markNormal,
  markException,
  truckDetail,
  uploadPOD,
  uploadISA,
  uploadBOL,
  getTruckInfo,
  addTruckSurcharge,
  getMBLTrackList,
  airMBLArrived,
  synchronousISF,
  cancelISF,
  isfMainifestSave,
  exportTruckExcel,
  GGTGetSCINList,
  GetDoTemplate,
  ChangeDoTemplate,
  PushMBLToGGT,
  GGTChangeSCIN,
  DeleteDoTemplate,
  MBLHoldDetail,
  getHoldReasonPages,
  updateHoldReason,
  addHoldReason,
  deleteHoldReason,
  getHoldReasonDropdown,
  holdMBL,
  realeaseMBL,
  getFMSReqeust,
  fmsMBLFollowUpList,
  pushToFMS,
  addFMSMBLFollowUp,
  onLoadMBL,
  inspectionSiteList,
  getMBLPriceTemplate,
  addMBLPriceTemplate,
  updateMBLPriceTemplate,
  getMBLPriceTemplateDetail,
  mblHoldRecordPages,
  mblHoldRecordSetInspec,
  mblHoldRecordSetStatus,
  mblHoldRecordSetBgLabel,
  GetImporterStatistics,
  saveInspectionSite,
  mblHoldRecordSetHoldInfo,
  searchOnLoadMBLT6,
  GGTGetAddress,
  updateMBLSendWayRemarks,
  sentISFMessage,
  getISFHsCode,
  rejectForecast,
  mblFileConfig,
  dispatchMblSendWay,
  voidMBL,
  deleteMBL,
  restoreMBL,
  dispatchPrivateMblSendWay,
  uploadOwerISA,
  manifestDetail,
  manifestRefuse,
  manifestAccepted,
  dispatchTransferOwner,
  dispatchTransferTruck,
  getMBLDispatchRecordList,
  dispatchTransferReadExcel,
  dispatchTransferPrivateToAmazon,
  dispatchTransferExpress,
  dispatchTransferAmazonToPrivate,
  batchUpdateDeliveryTime,
  createMbl,
  saveISFTemplate,
  getISFTemplate,
  deleteISFTemplate,
  deleteMblSendWay,
  readMainifestExcel,
  uploadMBLProduct,
  mergeMainifestSystem,
  mergeMainifestSystem1,
  mblHandler,
  updateMBLHandler,
  mblModifyInfo,
  modifyMBL,
  unknowProducts,
  readMainifest,
  directDeliveryPages,
  modifyDirectDelivery,
  syncAbiTrack,
  updateHoldResult,
  modifyDeliverySendWay,
  containerFinished,
  modifyMBLRemark,
  modifyDeliveryRemark,
  modifyMBLPU,
  mblHoldFiles,
  taxProductOptions,
  saveMondaryProduct,
  uploadMBLProduct1,
  forecastHanding,
  changeCalculator,
  submitForecast,
  getForecastPages,
  cancelForecast,
  supTemplateList,
  sendEmail,
  addSupTemplate,
  modifySupTemplate,
  deleteSupTemplate,
  getToBeUploadedQty,
  getForm7501PagedList,
  uploadForm7501,
  getRejectedRefuseReason,
  extractTaxContext,
  getFirmCodeOutputList,
  getAnDoStatusRecordPagedList,
  getMBLFileAnOrDoList,
  addAnAndDoFirmCode,
  sendAnEmail,
  sendDoEmail,
  insertDoFile,
  deleteMBLFile,
  downLoadMBLFile,
  getMBLFileList,
  getMBLFileList2,
  getMBLUploadFileTypeOption,
  previewMBLFile,
  uploadFile,
  getControlOverInvoicesPagedList,
  documentReview,
  returnForRetrial,
  cancel,
  sentUS,
  uploadInvoiceReviewFile,
  getInvoiceReviewRecordList,
  modifyInvoiceStatus,
  getLatestMBLProductDetail,
  systemInvoicePassForAdmin,
  reviewFeedbackForAdmin,
  getHistoryRecordList,
  getHistoryRecordDetailList,
  restoreVersion,
  GetSupplierTemplates,
  isActivedSupplierTemplate,
  deleteSupplierTemplate,
  confirmT11Clearance,
  revertT11ToDraft,
  aiGenerateInvoice,
  getInvoiceProductDetails,
  getClearanceStatus,
  getGroupList,
  getImporterDrapdown,
  addImporter
}
